module.exports = __webpack_public_path__ + "fonts/Stelvio-Grotesk-Medium.49d30f3.woff2";